/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { TaskViewVoModel } from '@well/delivery-libs/task-management/domain';
import { TaskTrackingDetailsComponent } from '../task-tracking-details/task-tracking-details.component';

@Component({
  selector: 'well-task-details-dialog',
  templateUrl: './task-details-dialog.component.html',
  styleUrls: ['./task-details-dialog.component.scss'],
  standalone: true,
  imports: [DialogModule, TranslateModule, TaskTrackingDetailsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskDetailsDialogComponent {
  displayDialog = signal(false);
  task = signal<TaskViewVoModel | undefined>(undefined);

  show(task: TaskViewVoModel | undefined): void {
    this.task.set(task);
    this.displayDialog.set(true);
  }
}
